import { Controller } from "@hotwired/stimulus";
import * as AutoKana from 'vanilla-autokana';

export default class extends Controller {
  static targets=[
    'name1',
    'name2',
    'kana1',
    'kana2',
    'age',
    'nameRequireError',
    'kanaRequireError',
    'kanaFormatError',
    'ageRequireError',
    'ageFormatError',
    'submitButton'
  ]

  connect() {
    this.setKana1ByName1()
    this.setKana2ByName2()
    this.controllSubmitButton()
  }

  // 必須項目のバリデーション
  requireName1InValid() {
    return this.name1Target.value == ''
  }

  requireName2InValid() {
    return this.name2Target.value == ''
  }

  requireKana1InValid() {
    return this.kana1Target.value == ''
  }

  requireKana2InValid() {
    return this.kana2Target.value == ''
  }

  requireAgeInValid() {
    return this.ageTarget.value == ''
  }

  // 必須項目のエラー表示制御
  controllRequireName1Error() {
    this.nameRequireErrorTarget.classList.add('regist_form__hide')

    const isInvalid = this.requireName1InValid()

    this.name1Target.classList.toggle('regist_form__error_input', isInvalid)
    this.nameRequireErrorTarget.classList.toggle('regist_form__hide', !isInvalid)
  }

  controllRequireName2Error() {
    this.nameRequireErrorTarget.classList.add('regist_form__hide')

    const isInvalid = this.requireName2InValid()

    this.name2Target.classList.toggle('regist_form__error_input', isInvalid)
    this.nameRequireErrorTarget.classList.toggle('regist_form__hide', !isInvalid)
  }

  controllRequireKana1Error() {
    this.kanaRequireErrorTarget.classList.add('regist_form__hide')

    const isInvalid = this.requireKana1InValid()

    this.kana1Target.classList.toggle('regist_form__error_input', isInvalid)
    this.kanaRequireErrorTarget.classList.toggle('regist_form__hide', !isInvalid)
  }

  controllRequireKana2Error() {
    this.kanaRequireErrorTarget.classList.add('regist_form__hide')

    const isInvalid = this.requireKana2InValid()

    this.kana2Target.classList.toggle('regist_form__error_input', isInvalid)
    this.kanaRequireErrorTarget.classList.toggle('regist_form__hide', !isInvalid)
  }

  controllRequireAgeError() {
    this.ageRequireErrorTarget.classList.add('regist_form__hide')

    const isAgeInvalid = this.requireAgeInValid()

    this.ageTarget.classList.toggle('regist_form__error_input', isAgeInvalid)
    this.ageRequireErrorTarget.classList.toggle('regist_form__hide', !isAgeInvalid)
  }

  // フォーマットバリデーション
  formatKana1InValid() {
    if (this.requireKana1InValid()) { return false }

    const pattern = /^[ァ-ンー]+$/
    const value = this.kana1Target.value

    return !pattern.test(value)
  }

  formatKana2InValid() {
    if (this.requireKana2InValid()) { return false }

    const pattern = /^[ァ-ンー]+$/
    const kana2Value = this.kana2Target.value

    return !pattern.test(kana2Value)
  }

  formatAgeInValid() {
    if (this.requireAgeInValid()) { return false }

    const value = this.ageTarget.value

    return isNaN(value) || value < 20
  }

  // フォーマットのエラー表示制御
  controllFormatKana1Error() {
    this.controllFormtKanaErrorMessage()

    if (this.requireKana1InValid()) { return }
    this.kana1Target.classList.toggle('regist_form__error_input', this.formatKana1InValid())
  }

  controllFormatKana2Error() {
    this.controllFormtKanaErrorMessage()

    if (this.requireKana2InValid()) { return }
    this.kana2Target.classList.toggle('regist_form__error_input', this.formatKana2InValid())
  }

  controllFormtKanaErrorMessage() {
    this.kanaFormatErrorTarget.classList.add('regist_form__hide')

    const kana1IsInvald = this.formatKana1InValid()
    const kana2IsInvald = this.formatKana2InValid()

    this.kanaFormatErrorTarget.classList.toggle('regist_form__hide', !kana1IsInvald && !kana2IsInvald)
  }

  controllFormatAgeError() {
    this.controllFormatAgeErrorMessage()

    if (this.requireAgeInValid()) { return }
    this.ageTarget.classList.toggle('regist_form__error_input', this.formatAgeInValid())
  }

  controllFormatAgeErrorMessage() {
    this.ageFormatErrorTarget.classList.add('regist_form__hide')

    const isFormatInvalid = this.formatAgeInValid()

    this.ageFormatErrorTarget.classList.toggle('regist_form__hide', !isFormatInvalid)
  }

  controllSubmitButton() {
    const isRequireInvalid = this.requireName1InValid()
      || this.requireName2InValid()
      || this.requireKana1InValid()
      || this.requireKana2InValid()
      || this.requireAgeInValid()
    const isFormatInvalid = this.formatKana1InValid()
      || this.formatKana2InValid()
      || this.formatAgeInValid()

    this.submitButtonTarget.disabled = isRequireInvalid || isFormatInvalid
    this.submitButtonTarget.classList.toggle('regist_form__button--disabled', isRequireInvalid || isFormatInvalid)
  }

  // AutoKana
  setKana1ByName1() {
    AutoKana.bind('#name1', '#kana1', { katakana: true })
  }

  setKana2ByName2() {
    AutoKana.bind('#name2', '#kana2', { katakana: true })
  }

  // ひらがなをカタカナに変換する関数
  convertHiraganaToKatakana(e) {
    const value = e.target.value
    const inputString = value.trim()

    const convertedValue = inputString.replace(/[\u3041-\u3096]/g, function (match) {
      return String.fromCharCode(match.charCodeAt(0) + 0x60)
    })

    e.target.value = convertedValue
  }

  // 半角数字に変換
  convertToHalfWidth() {
    const inputValue = this.ageTarget.value

    // 全角数字を半角数字に変換 & 全角マイナス（－、ー）を削除
    const convertedValue = inputValue.replace(/[０-９－ー-\s　]/g, (match) => {
      if (match === "－" || match === "ー" || match === "-") return "" // ハイフンを削除
      if (match === " " || match === "　") return "" // スペースを削除
      return String.fromCharCode(match.charCodeAt(0) - 0xFEE0)
    });

    // 入力フィールドに変換後の値を設定
    this.ageTarget.value = convertedValue
  }
}
